export const parseResourceLimit = type =>
  ({
    relevance: 'Pertinência',
    time: 'Tempo',
  }[type])
